import { useEffect } from 'react'
import { X, AlertTriangle, Info, CheckCircle } from 'lucide-react'
import './ConfirmModal.css'

export default function ConfirmModal({
    isOpen,
    onClose,
    onConfirm,
    title,
    message,
    confirmText = 'Confirmer',
    cancelText = 'Annuler',
    type = 'warning', // 'warning', 'danger', 'info', 'success'
    loading = false
}) {
    useEffect(() => {
        const handleEscape = (e) => {
            if (e.key === 'Escape' && isOpen) {
                onClose()
            }
        }
        document.addEventListener('keydown', handleEscape)
        return () => document.removeEventListener('keydown', handleEscape)
    }, [isOpen, onClose])

    if (!isOpen) return null

    const getIcon = () => {
        switch (type) {
            case 'danger':
                return <AlertTriangle size={24} className="text-error" />
            case 'success':
                return <CheckCircle size={24} className="text-success" />
            case 'info':
                return <Info size={24} className="text-info" />
            default:
                return <AlertTriangle size={24} className="text-warning" />
        }
    }

    const getButtonClass = () => {
        switch (type) {
            case 'danger':
                return 'btn-danger'
            case 'success':
                return 'btn-success'
            default:
                return 'btn-primary'
        }
    }

    return (
        <div className="confirm-modal-overlay" onClick={onClose}>
            <div className="confirm-modal" onClick={(e) => e.stopPropagation()}>
                <button className="confirm-modal-close" onClick={onClose}>
                    <X size={18} />
                </button>

                <div className="confirm-modal-icon">
                    {getIcon()}
                </div>

                <h3 className="confirm-modal-title">{title}</h3>

                {message && (
                    <p className="confirm-modal-message">{message}</p>
                )}

                <div className="confirm-modal-actions">
                    <button
                        className="btn btn-secondary"
                        onClick={onClose}
                        disabled={loading}
                    >
                        {cancelText}
                    </button>
                    <button
                        className={`btn ${getButtonClass()}`}
                        onClick={onConfirm}
                        disabled={loading}
                    >
                        {loading ? 'Chargement...' : confirmText}
                    </button>
                </div>
            </div>
        </div>
    )
}
